import { HEADERS, USUARIO_ID } from "../ConsumeService";

export class PerfilService {

    static consultarPerfiles() {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_URL_SERVICE_PERFILES_GET, {
                method: "POST",
                headers: HEADERS
            }).then((res) => res.json()).then((data) => {
                resolve(data.SDTPerfil);
            });
        });
    }

    static eliminarPerfil(perfil) {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_URL_SERVICE_PERFILES_DELETE, {
                method: "POST",
                headers: HEADERS,
                body: JSON.stringify({...perfil })
            }).then((res) => res.json()).then((data) => {
                resolve(data);
            });
        });
    }

    static editarPerfil(perfil) {
        
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_URL_SERVICE_PERFILES_PUT, {
                method: "POST",
                headers: HEADERS,
                body: JSON.stringify({ ...USUARIO_ID, ...perfil })
                //body: JSON.stringify({ ...perfil })
            }).then((res) => res.json()).then((data) => {
                resolve(data);
            });
        });
        
    }

    static crearPerfil(perfil) {
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_URL_SERVICE_PERFILES_POST, {
                method: "POST",
                headers: HEADERS,
                body: JSON.stringify({...perfil })
            }).then((res) => res.json()).then((data) => {
                resolve(data);
            });
        });
    }
}